export const measurements = ['metric', 'imperial'];

export const rangeFilterNames = ['created_at', 'issue_date'];

export const apiVersion = import.meta.env.VITE_APP_DEFAULT_API_VERSION;

export const modalSizes = {
  xl: '1200px',
  lg: '800px',
  md: '500px',
  sm: '450px',
  /**
   * Allow for dynamic sizing inside the modal
   */
  unset: 'unset',
};

// Intercom renders at z-index 2147483000; keep modals above it and snackbars above modals.
export const modalZIndex = 2147483001;
/** Z-index for overlays (menus, dropdowns) so they appear above modals when opened inside a dialog. */
export const overlayZIndex = 2147483100;
export const snackbarZIndex = 2147484002;
// make sure devtools (mocked requests, tanstack query) are on top of everything else.
export const devtoolsZIndex = 2147485003;

export const noteConfig = {
  maxLength: 1500,
};

export const unpaginatedListLimit = 10_000;

export const pollingDurations = {
  fast: 3_000,
  default: 5_000,
};

export const maxDateRangeDays = {
  threeMonths: 92, // 3 month range for longest month combination (eg 31 + 30 + 31)
  sixMonths: 184, // 6 month range for longest month combination (eg 31 + 30 + 31 + 31 + 30 + 31)
};
